<div class="custom-toolbar">
  <div class="custom-toolbar-subdivision-left custom-toolbar-element">
    <span class="info-message">
      Un taux de prise (pondération %) renseigné à 0 signifie que les effectifs liés à ce repas ne seront pas comptabilisés dans les effectifs pondérés de fin de mois
    </span>
  </div>
  <div class="custom-toolbar-subdivision-right">
    <div class="custom-button-container">
      <yo-button
        iconClass="fas fa-save"
        [theme]="ButtonThemeEnum.SAVE"
        (onClick)="save()"
        tooltip="Enregistrer les pondérations de repas">
      </yo-button>
    </div>
  </div>
</div>

<dx-data-grid
  keyExpr="repasId"
  height="100%"
  [dataSource]="repasPonderationList"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  [showRowLines]="true"
  [showBorders]="true"
  columnResizingMode="widget">

  <dxi-column dataField="repasLibelle" caption="Repas" [allowFiltering]="true"></dxi-column>
  <dxi-column dataField="ponderation" caption="Pondération (%)" [width]="180"
              [allowFiltering]="false"
              cellTemplate="ponderationTemplate">
  </dxi-column>

  <div *dxTemplate="let cell of 'ponderationTemplate'">
    <dx-number-box
      [value]="cell.row.data.ponderation"
      [min]="0"
      [max]="100"
      [format]="'#0.####'"
      placeholder="100"
      (onValueChanged)="onPonderationChange(cell.row.data, $event.value)">
    </dx-number-box>
  </div>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-sorting mode="multiple"></dxo-sorting>
  <dxo-pager [visible]="false"></dxo-pager>

</dx-data-grid>
